import { useEffect, useState } from "react";
import { FolderOpen, ExternalLink, FileText } from "lucide-react";

const BASE = import.meta.env.BASE_URL;

export default function BankerArtifacts() {
  const [artifacts, setArtifacts] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("banker_token");
    if (!token) return;
    (async () => {
      try {
        const r = await fetch(`${BASE}api/banker/artifacts`, { headers: { "x-banker-token": token } });
        if (r.ok) setArtifacts(await r.json());
      } catch {}
      setLoading(false);
    })();
  }, []);

  const filtered = artifacts.filter(a => !q || a.title.toLowerCase().includes(q.toLowerCase()) || (a.summary || "").toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-3xl font-bold flex items-center gap-2"><FolderOpen className="w-7 h-7 text-[#FF5C00]" /> Artifacts Library</h1>
        <p className="text-white/50 text-sm mt-1">Every Zoom, email, doc, and note you've uploaded. Searchable.</p>
      </div>
      <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search artifacts..."
        className="w-full max-w-md bg-white/[0.04] border border-white/[0.1] rounded-lg px-3 py-2 text-sm placeholder-white/30 focus:outline-none focus:border-[#FF5C00]/40" />
      {loading ? (
        <div className="space-y-2">{[...Array(3)].map((_, i) => <div key={i} className="h-24 bg-white/[0.04] rounded-lg animate-pulse" />)}</div>
      ) : filtered.length === 0 ? (
        <div className="bg-white/[0.04] border border-white/[0.1] rounded-xl p-12 text-center">
          <p className="text-white/40 text-sm">{artifacts.length === 0 ? "No artifacts yet. Upload your first one from any task." : "No matches."}</p>
        </div>
      ) : (
        <div className="space-y-2">
          {filtered.map(a => (
            <div key={a.id} className="bg-white/[0.04] border border-white/[0.08] rounded-xl p-5">
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 rounded-lg bg-[#FF5C00]/15 flex items-center justify-center flex-shrink-0">
                  <FileText className="w-4 h-4 text-[#FF5C00]" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <p className="text-[10px] uppercase tracking-wider text-white/40 font-mono">{a.kind.replace("_", " ")}</p>
                    <span className="text-white/30 text-[10px]">· {new Date(a.createdAt).toLocaleDateString()}</span>
                  </div>
                  <p className="text-white font-medium mt-1">{a.title}</p>
                  {a.url && <a href={a.url} target="_blank" rel="noreferrer" className="text-[#FF5C00] hover:underline text-xs flex items-center gap-1 mt-1"><ExternalLink className="w-3 h-3" /> Open</a>}
                  {a.fileUrl && (
                    <a href={`${BASE}api/banker/artifacts/${a.id}/download?token=${encodeURIComponent(localStorage.getItem("banker_token") || "")}`}
                      data-testid={`download-artifact-${a.id}`}
                      className="text-[#FF5C00] hover:underline text-xs flex items-center gap-1 mt-1">
                      <ExternalLink className="w-3 h-3" /> Download {a.fileName || "file"}{a.fileSize ? ` (${Math.round(a.fileSize / 1024)} KB)` : ""}
                    </a>
                  )}
                  {a.summary && <p className="text-white/60 text-xs mt-2 leading-relaxed line-clamp-3">{a.summary}</p>}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
